import { render, staticRenderFns } from "./LegoControlCardAuditoriaCalificacion.vue?vue&type=template&id=0480d784&scoped=true"
import script from "./LegoControlCardAuditoriaCalificacion.vue?vue&type=script&lang=js"
export * from "./LegoControlCardAuditoriaCalificacion.vue?vue&type=script&lang=js"
import style0 from "./LegoControlCardAuditoriaCalificacion.vue?vue&type=style&index=0&id=0480d784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0480d784",
  null
  
)

export default component.exports